export default "__VITE_ASSET__Bekvlv_u__"